import http from '@/services/http/index'
import endpoints from '@/services/http/endpoints'
import type { AxiosResponse } from 'axios'
import type { VolunteerCooperationResponse, ChildEditionId } from '@/types'

export default {
  get(childEditionId: ChildEditionId): Promise<AxiosResponse<VolunteerCooperationResponse>> {
    return http.get(endpoints.get('volunteerCooperation', { childEditionId }))
  },
  toggle(childEditionId: ChildEditionId): Promise<AxiosResponse<VolunteerCooperationResponse>> {
    return http.post(endpoints.get('volunteerCooperation', { childEditionId }))
  }
}
